import { errorTypes } from '@/configuration/pages/ConfigurationPage/ReturnPolicy/PolicyRulesConfiguration/PolicyRuleDetailConfiguration/constants'

export const hasPlacementError = errors => errors.some(e => e.type === errorTypes.actionMessagePlacementEmpty)

export const getMissingLanguages = (errors, errorType) => {
  const fieldError = errors.find(e => e.type === errorType)

  if (!fieldError) return []

  return fieldError.missingLanguages
}
